var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrackedProjectsWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 19.2502C3.83696 19.2502 3.20107 18.9869 2.73223 18.518C2.26339 18.0492 2 17.4133 2 16.7502V5.75024C2 5.0872 2.26339 4.45132 2.73223 3.98248C3.20107 3.51364 3.83696 3.25024 4.5 3.25024H6.08375C6.30327 2.87002 6.61905 2.55432 6.99933 2.33488C7.34344 2.13632 7.72938 2.02293 8.12499 2.00331C8.19396 1.99989 8.24935 1.9441 8.25625 1.87539C8.28491 1.58972 8.41131 1.32117 8.61612 1.11636C8.85054 0.88194 9.16848 0.750244 9.5 0.750244H10.5C10.6642 0.750244 10.8267 0.782576 10.9784 0.845395C11.13 0.908213 11.2678 1.00029 11.3839 1.11636C11.5 1.23243 11.592 1.37023 11.6548 1.52189C11.7017 1.63497 11.7316 1.75411 11.7438 1.87545C11.7506 1.94414 11.806 1.99992 11.8749 2.00337C12.2704 2.02317 12.6561 2.13664 13 2.3352C13.38 2.55462 13.6956 2.87021 13.915 3.25024H15.5C16.163 3.25024 16.7989 3.51364 17.2678 3.98248C17.7366 4.45132 18 5.0872 18 5.75024V16.7502C18 17.4133 17.7366 18.0492 17.2678 18.518C16.7989 18.9869 16.163 19.2502 15.5 19.2502H4.5Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 3.25024C14.25 4.63096 13.1307 5.75024 11.75 5.75024H8.25C6.86929 5.75024 5.75 4.63096 5.75 3.25024",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.3414H7.5L9.375 8.75049L11.25 11.2505L12.5 9.43231L13.125 10.3414H15",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 14.2505H12.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 16.7505H10",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackedProjectsWhite);
export default __webpack_public_path__ + "static/media/trackedProjectsWhite.4514c32e37080708c922603df48fffba.svg";
export { ForwardRef as ReactComponent };